import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';
import { LocalizedComponentProps, withLocalization } from 'bernie-l10n';

import { CurrentHotelStore } from 'stores/current-hotel-store';

import { HotelMapModel } from 'models';

import { UitkCard, UitkCardContent } from 'uitk-react-cards';
import { UitkFigureAspectRatioType } from 'uitk-react-images';
import { UitkLayoutColumns } from 'uitk-react-layout-columns';

import { LazyImage } from 'components/common/lazy/lazy-image';
import { LocationEditorial } from './internals/location-editorial';
import { LocationScore } from 'components/infosite/whats-around/internals/location-score';
import { NavigationRefs } from 'components/infosite/navigation/navigation-refs.tsx';
import { WhatsAroundContent } from './internals/whats-around-content';
import { WhatsAroundHeader } from './internals/whats-around-header';
import { WhatsAroundMap } from './whats-around-map';

export interface WhatsAroundCardProps extends LocalizedComponentProps {
  currentHotel?: CurrentHotelStore;
  mapModel?: HotelMapModel;
}

@withLocalization
@inject('currentHotel')
@observer
export class WhatsAroundCard extends React.Component<WhatsAroundCardProps> {
  public render() {
    const { currentHotel, mapModel } = this.props;
    const whatsAroundModel = currentHotel.hotel && currentHotel.hotel.locationInfo && currentHotel.hotel.locationInfo.whatsAroundModule;
    const locationScore = currentHotel && currentHotel.propertyLocationScoreInfo;
    const walkScoreModel = (currentHotel.hotel && currentHotel.hotel.locationInfo && currentHotel.hotel.locationInfo.walkScore) || {};

    if (!whatsAroundModel) {
      return null;
    }

    return (
      <ErrorBoundary label="hotel.information.whatsAround_1">
        <div className="all-y-margin-three" data-stid="whats-around" ref={NavigationRefs.Location}>
          <UitkCard>
            <UitkCardContent className="uitk-grid uitk-cell">
              <div className="uitk-cell s-cell-1-1 l-cell-1-3 xl-cell-1-3 all-y-padding-three l-x-padding-three xl-x-padding-three">
                <WhatsAroundHeader title={whatsAroundModel.title} />

                <LocationEditorial
                  destinationPageLink={whatsAroundModel.destinationPageLink}
                  body={whatsAroundModel.locationEditorial}
                  neighborhoodTitle={whatsAroundModel.neighborhood}
                />

                {locationScore && <LocationScore score={locationScore.score} tags={locationScore.tags} data-stid="location-score" />}
              </div>
              <div className="uitk-cell s-cell-1-1 l-cell-2-3 xl-cell-2-3 all-y-padding-three l-x-padding-three xl-x-padding-three">
                {mapModel &&
                  whatsAroundModel.mapImageUrl && (
                    <LazyImage experimentName="PWA_LAZY_LOAD_IMAGES">
                      <div data-stid="whats-around-map" className="all-x-margin-three all-y-margin-three">
                        <WhatsAroundMap
                          src={whatsAroundModel.mapImageUrl}
                          mapModel={mapModel}
                          rfrr=":WhatsAroundMap.Open"
                          ratio={UitkFigureAspectRatioType.R21_9}
                        />
                      </div>
                    </LazyImage>
                  )}

                <UitkLayoutColumns columns={2} minWidth="seventy_two">
                  <WhatsAroundContent model={whatsAroundModel} walkScoreModel={walkScoreModel} />
                </UitkLayoutColumns>
              </div>
            </UitkCardContent>
          </UitkCard>
        </div>
      </ErrorBoundary>
    );
  }
}
